import GenericDialog from "./generic";
import LabeledField from "providers/labeledField";
import { useTranslation } from "react-i18next";

const InstallerDetailsDialog = ({
  installer,
  isOpen,
  onClose,
}: {
  installer: any;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <GenericDialog
      isOpen={isOpen}
      onExit={onClose}
      title={t("dialog.installer.title")}
      size="sm"
    >
      <div className="grid grid-cols-1 gap-1 pb-2 md:gap-2">
        <LabeledField
          label={`${t("device.installer.name")}: `}
          id={"name"}
          className="text-txt-sm"
          textColor="secondary"
        >
          <label
            className={`whitespace-normal break-words text-secondary text-txt-md font-bold`}
          >
            {`${installer?.firstName || ""} ${
              installer?.lastName || ""
            }`}
          </label>
        </LabeledField>
        <LabeledField
          label={`${t("device.installer.email")}: `}
          id={"date"}
          className="text-txt-sm"
          textColor="secondary"
        >
          <label
            className={`whitespace-normal break-words text-secondary text-txt-md font-bold`}
          >
            {installer?.email || ""}
          </label>
        </LabeledField>
        <LabeledField
          label={`${t("device.installer.phone")}: `}
          id={"location"}
          className="text-txt-sm"
          textColor="secondary"
        >
          <label
            className={`whitespace-normal break-words text-secondary text-txt-md font-bold`}
          >
            {installer?.phone || ""}
          </label>
        </LabeledField>
      </div>
    </GenericDialog>
  );
};

export default InstallerDetailsDialog;
